import axios from "axios";
import { API_URL } from "const/constants";

const BASE = `${API_URL}/referral-leads`;

export const buildLeadQueueParams = ({
  page,
  size,
  search,
  state,
  partnerId,
  sortBy,
  sortDirection,
}) => {
  const params = {
    page,
    size,
    sortBy: sortBy || "sentToOrgAt",
    sortDirection: sortDirection || "desc",
  };
  const trimmed = String(search || "").trim();
  if (trimmed) params.search = trimmed;
  if (state) params.state = state;
  if (partnerId) params.partnerId = partnerId;
  return params;
};

export const listReferralLeads = async (filters) => {
  const { data } = await axios.get(BASE, { params: buildLeadQueueParams(filters) });
  return data?.data ?? data;
};

export const getReferralLead = async (id) => {
  const { data } = await axios.get(`${BASE}/${id}`);
  return data?.data ?? data;
};

export const activateReferralLead = (id, payload) =>
  axios.post(`${BASE}/${id}/activate`, payload || {});

export const rejectReferralLead = (id, reason) => axios.post(`${BASE}/${id}/reject`, { reason });

export const fetchAssignableOfficers = async () => {
  const { data } = await axios.get(`${BASE}/assignable-officers`);
  return data?.data ?? data;
};

export const buildPartnerReferralParams = ({ page, size, search, state }) => {
  const params = { page, size };
  const trimmed = String(search || "").trim();
  if (trimmed) params.search = trimmed;
  if (state) params.state = state;
  return params;
};

/**
 * Everything one partner referred: portal leads plus clients the office attributed to them
 * directly, which have no lead (leadId null, state EXISTING).
 */
export const listPartnerReferrals = async (partnerId, filters) => {
  const { data } = await axios.get(`${API_URL}/referral-partners/${partnerId}/referred-clients`, {
    params: buildPartnerReferralParams(filters),
  });
  return data?.data ?? data;
};
